<template>
	<div>
		<b-navbar
			toggleable="lg"
			fixed="top"
			class="transparent"
			:class="{
				solid: scrollPosition >= 80 || isMobile,
				shadow: scrollPosition >= 80 || isMobile,
				'navbar-dark': scrollPosition < 80,
			}"
		>
			<b-navbar-toggle target="navbar-collapse" class="ml-auto">
				<i class="fas fa-bars"></i>
			</b-navbar-toggle>
			<b-collapse id="navbar-collapse" is-nav>
				<b-navbar-nav class="ml-auto">
					<b-nav-item :to="{ name: 'components' }">Inicio</b-nav-item>
					<b-nav-item :to="{ name: 'bases' }">Bases</b-nav-item>
					<b-nav-item :to="{ name: 'ganadores' }">Publicación de Ganadores</b-nav-item>
					<b-nav-item :to="{ name: 'contacto' }">Contacto</b-nav-item>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
		<Banner v-if="!segundaEtapa" v-on:scrollRegistro="irRegistro" />
		<Banner2 v-else v-on:scrollRegistro="irRegistro" />
		<Register v-on:segundaEtapa="cambiaEtapa"></Register>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import Banner from "./components/Banner";
import Banner2 from "./components/Banner2";
import Register from "./components/Register";
import FooterBack from "./components/FooterBack";
export default {
	name: "components",
	components: {
		Banner,
		Banner2,
		Register,
		FooterBack,
	},
	data() {
		return {
			scrollPosition: 0,
			segundaEtapa: false,
			isMobile: this.$mobile(),
		};
	},
	mounted() {
		this.updateScroll();
		setTimeout(() => {
			this.$scrollTo('#banner_desktop', 0, {
				offset: 0,
			});
		}, 300);
		window.addEventListener("scroll", this.updateScroll);
	},
	methods: {
		cambiaEtapa() {
			console.log('emitted root')
			this.segundaEtapa = true;
		},
		irRegistro() {
			this.$scrollTo('#register_form', 800, {
				offset: -100,
			});
		},
		updateScroll() {
			this.scrollPosition = window.scrollY;
		},
	},
};
</script>
<style>
.navbar.transparent {
	background-color: transparent;
}
.navbar.transparent.solid {
	background-color: #fff;
}
.navbar.transparent.solid .navbar-toggler {
	color: #000 !important;
}
@media (max-width: 991.98px) {
	.navbar-collapse {
		width: calc(100% - 0.5rem)!important;
		top: 45px!important;
		margin: 0.25rem!important;
	}
}
</style>
